import { CategoryItem } from "./types";

/**
 * Predefined styles for the CategoryNavigationTabs component.
 */
export const CATEGORY_NAV_STYLES = {
  root: "w-full flex justify-center px-0 sm:px-0",
  list: "mx-auto max-sm:justify-between bg-white gap-1 sm:gap-[9px] rounded-full border border-ticketon-light-gray shadow-component grid text-sm p-[10px] sm:p-[10px] w-full max-w-[712px] h-auto shadow-sm",
  trigger: {
    base: "w-full flex-1 inline-flex items-center justify-center whitespace-nowrap rounded-full px-3 sm:px-4 lg:px-6 py-2 text-sm font-semibold transition-all box-border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 z-0",
    inactive: "!text-primary hover:!bg-blue-50 !bg-transparent",
    active: "!bg-primary !text-white !shadow-sm hover:!bg-blue-900 !z-10",
  },
} as const;

/**
 * Default categories for the main navigation.
 */
export const DEFAULT_CATEGORIES: CategoryItem[] = [
  { value: "events", label: "Events", href: "/events" },
  { value: "travel", label: "Travel", href: "/travel" },
  { value: "movies", label: "Movies", href: "/movies" },
  { value: "fanshop", label: "Fan Shop", href: "/fanshop" },
] as const;
